/**
 * NAZWA SYSTEMU MASZYNY — z poprawką na rejestr, który kłamie.
 *
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *  ⚠️⚠️ ZGŁOSZONE Z PESA (28.08.2026): karta maszyny mówiła „Windows 10 Pro 25H2 build 26200",
 *  a NinjaOne na tej samej maszynie „Microsoft Windows 11 Pro (Kompilacja 26200)". Windows 11 to
 *  jest, portal pokazywał Windows 10.
 *
 *  ⚠️ TO NIE JEST BŁĄD AGENTA. `HKLM\...\CurrentVersion\ProductName` na Windows 11 nadal zwraca
 *  „Windows 10 Pro" — to znana decyzja Microsoftu, nie usterka odczytu. Agent czyta poprawnie
 *  i dlatego OBOK nazwy przysyła numer budowy (`fakty-systemu.ts` ma to opisane od początku:
 *  „bez numeru budowy nie da się rozstrzygnąć, na czym ta maszyna naprawdę stoi").
 *
 *  ⚠️ POPRAWIAMY W PORTALU, NIE W AGENCIE, i to jest cała różnica praktyczna. Poprawka w agencie
 *  wymagałaby nowego podpisanego wydania i objęła TYLKO maszyny, które je wezmą — a nazwę widać na
 *  każdej karcie już teraz. Tutaj działa dla wszystkich agentów, także tych sprzed zmiany, a surowa
 *  wartość z rejestru zostaje w bazie nietknięta.
 *
 *  ⚠️ PRÓG 22000 TO PIERWSZA BUDOWA WINDOWS 11 (21H2). Wyżej idą 22621, 22631, 26100, 26200…
 *  Windows Server ma budowy z tego samego zakresu (2025 = 26100), ale jego `ProductName` mówi
 *  „Windows Server 2025", więc warunek „nazwa mówi Windows 10" go nie dotyka. Dlatego reguła
 *  patrzy na JEDNO I DRUGIE — sam numer budowy przemianowałby serwery.
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 */

/** Pierwsza budowa Windows 11. Wszystko od niej w górę to jedenastka. */
export const PIERWSZA_BUDOWA_WIN11 = 22000;

/**
 * Numer budowy wyłuskany z tego, co przysyła agent.
 *
 * ⚠️ DWIE POSTACIE, bo agent ma dwie drogi: normalnie składa `25H2 build 26200` z rejestru,
 * a gdy rejestr milczy, wstawia `os.release()`, czyli `10.0.26200`.
 */
export function budowaSystemu(osVersion: string | null | undefined): number | null {
  if (typeof osVersion !== 'string') return null;
  const zRejestru = /\bbuild\s+(\d{4,6})\b/i.exec(osVersion);
  if (zRejestru !== null) return Number(zRejestru[1]);
  const zJadra = /^\d+\.\d+\.(\d{4,6})/.exec(osVersion.trim());
  return zJadra === null ? null : Number(zJadra[1]);
}

/**
 * Nazwa systemu do POKAZANIA. Zwraca `osName` bez zmian wszędzie tam, gdzie nie ma dowodu,
 * że rejestr kłamie — poprawka jest wąska celowo.
 */
export function nazwaSystemu(osName: string | null | undefined, osVersion: string | null | undefined): string | null {
  if (typeof osName !== 'string' || osName.trim() === '') return null;
  const budowa = budowaSystemu(osVersion);
  if (budowa === null || budowa < PIERWSZA_BUDOWA_WIN11) return osName;
  /**
   * ⚠️ PODMIENIAMY SAMĄ LICZBĘ, ZOSTAWIAJĄC EDYCJĘ. „Windows 10 Pro" → „Windows 11 Pro”,
   * „Windows 10 Enterprise LTSC" → „Windows 11 Enterprise LTSC". Sklejanie własnego napisu
   * („Windows 11") gubiłoby edycję, a to ona odpowiada na pytanie, czy maszyna ma Pro.
   */
  return osName.replace(/\bWindows\s+10\b/i, 'Windows 11');
}
